var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 940,
    height: 408,
    viewBox: "0 0 940 408",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M463.88 226.196V241.602H412.859V226.196H463.88ZM419.311 145.747V241.602H399.56V145.747H419.311ZM457.231 184.787V199.797H412.859V184.787H457.231ZM463.814 145.747V161.218H412.859V145.747H463.814ZM553.415 145.747V241.602H533.664L495.151 177.348V241.602H475.401V145.747H495.151L533.73 210.067V145.747H553.415ZM588.043 145.747L606.082 179.191L624.12 145.747H646.701L618.854 193.279L647.426 241.602H624.647L606.082 207.5L587.517 241.602H564.606L593.244 193.279L565.331 145.747H588.043ZM694.892 199.534H670.27L670.138 185.972H690.81C694.453 185.972 697.438 185.511 699.764 184.589C702.09 183.624 703.824 182.241 704.965 180.442C706.15 178.598 706.742 176.36 706.742 173.727C706.742 170.742 706.172 168.328 705.03 166.485C703.933 164.642 702.2 163.303 699.83 162.469C697.503 161.635 694.497 161.218 690.81 161.218H677.117V241.602H657.367V145.747H690.81C696.384 145.747 701.366 146.274 705.755 147.327C710.187 148.381 713.94 149.982 717.012 152.133C720.085 154.284 722.433 157.005 724.057 160.296C725.68 163.544 726.492 167.407 726.492 171.883C726.492 175.833 725.593 179.476 723.793 182.812C722.038 186.147 719.251 188.868 715.432 190.975C711.658 193.082 706.72 194.245 700.62 194.464L694.892 199.534ZM694.036 241.602H664.872L672.574 226.196H694.036C697.503 226.196 700.334 225.648 702.529 224.551C704.723 223.409 706.347 221.873 707.4 219.942C708.454 218.011 708.981 215.795 708.981 213.293C708.981 210.484 708.498 208.048 707.532 205.985C706.61 203.923 705.118 202.343 703.055 201.245C700.993 200.104 698.271 199.534 694.892 199.534H675.866L675.998 185.972H699.698L704.24 191.304C710.078 191.217 714.774 192.248 718.329 194.399C721.928 196.505 724.539 199.248 726.163 202.628C727.831 206.007 728.665 209.628 728.665 213.49C728.665 219.635 727.326 224.814 724.649 229.027C721.972 233.197 718.044 236.335 712.865 238.442C707.73 240.548 701.453 241.602 694.036 241.602Z",
    fill: "#00685E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 9,
    width: 41,
    height: 161,
    fill: "#00685E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 32,
    width: 51,
    height: 237,
    fill: "#00857D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 61,
    width: 37,
    height: 143,
    fill: "#279989"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 100,
    width: 34,
    height: 133,
    fill: "#14A3C7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 86,
    width: 36,
    height: 83,
    fill: "#41B6E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 169,
    width: 36,
    height: 101,
    fill: "#8DC8E8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 233,
    width: 34,
    height: 112,
    fill: "#41B6E6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 204,
    width: 37,
    height: 123,
    fill: "#5CB8B2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 170,
    width: 41,
    height: 169,
    fill: "#009639"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 220,
    width: 51,
    height: 150,
    fill: "#84BD00"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 189,
    width: 37,
    height: 82,
    fill: "#A4D65E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 217,
    width: 40,
    height: 78,
    fill: "#C2E189"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 133,
    width: 40,
    height: 84,
    fill: "#78BE20"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 101,
    width: 37,
    height: 88,
    fill: "#009A44"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 61,
    width: 51,
    height: 159,
    fill: "#007864"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 269,
    width: 51,
    height: 131,
    fill: "#A0D1CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f60cfc2afef05140e1fe142e435cf78a.svg";
export { ForwardRef as ReactComponent };